import React, { useEffect } from 'react';
import { TReportHeader } from '@@config/report';

type TReportSupplementalsProps = {
    readonly header: TReportHeader; // Add header to get PDF_URL directly
};

const ReportSupplementals: React.FC<TReportSupplementalsProps> = ({ header }) => {
    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            if ((e.ctrlKey || e.metaKey) && e.key === 'p') {
                e.preventDefault();
                if (header?.PDF_URL?.VALUE) {
                    window.open(header.PDF_URL.VALUE, '_blank');
                }
            }
        };

        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [header?.PDF_URL]);

    return (
        <div className='report-supplementals flex items-center justify-end'>
            {header.SHARE_URL && (
                <a className='btn btn-light--static rounded' href={header.SHARE_URL.VALUE}>
                    <img
                        src='//gia.edu/img/icons/share-icon.svg'
                        alt=''
                        aria-hidden='true'
                        className='mr-2 hidden h-5 w-6 align-middle sm:inline-block'
                    />
                    <span>{header.SHARE_URL.LABEL}</span>
                </a>
            )}
            {header.PDF_URL && (
                <a href={header.PDF_URL.VALUE} className='btn btn-primary rounded' target='_blank' rel='noreferrer'>
                    <img
                        src='//gia.edu/img/icons/cloud-download.svg'
                        alt=''
                        aria-hidden='true'
                        className='mr-2 hidden h-5 w-6 align-middle sm:inline-block'
                    />
                    <span>{header.PDF_URL.LABEL}</span>
                </a>
            )}
        </div>
    );
};

export type { TReportSupplementalsProps };
export default ReportSupplementals;
